<script>
import component from './base.vue';
import Api from '@/utils/api';

export default component.extend({
  computed: {
    disableCustomer: () => false,
    disableProofreader: () => false,
  },
  methods: {
    sendToCustomer() {
      this.ajaxCustomer = true;
      Promise.all([
        Api.reports.sendReport.customer(this.$route.params.id),
        this.acceptReport(),
      ]).then(() => {
        this.$root.$emit('notification', {
          message: 'Notification was successfully sended to Customer',
          type: 'info',
          show: true,
        });
      }).catch(() => {
        this.$root.$emit('notification', {
          message: 'Error while sending notification',
          type: 'error',
          show: true,
        });
      }).finally(() => {
        this.ajaxCustomer = false;
      });
    },
    acceptReport() {
      if (this.errorsDataToSend.ErrorConclusionList.length != 0) {
        return Api.reports.sendToCustomer(this.errorsDataToSend);
      }
      return Promise.resolve();
    },
  },
});
</script>
